import { Navigate, Route, Routes } from "react-router-dom";
import LoginForm from "../layouts/LoginLayout/LoginForm";
import CreateAccount from "../layouts/LoginLayout/CreateAnAccount";
import ForGotPassword from "../layouts/LoginLayout/ForgotPassword";
import OTPVerification from "../layouts/LoginLayout/OTPVerification";
import TwoStepWithCalidation from "../layouts/LoginLayout/TwoStepVerification";
import OrtpVerifyViaLogin from "../layouts/LoginLayout/OtpVerficationCodeLogin";
import TwoStepViaLogin from "../headers/TwoStepViaLogin";
import TwostepForgot from "../layouts/LoginLayout/TwoStepForForgotPassword";
import Dashboard from "../../pages/Dashboard";
import FileFormOnline from "../../pages/fillForms/FillAFormOnline";
import FormStart from "../../pages/wizardCases/FormStart";
import DashboardLayout from "../dashboardLaayout";
import { VisaApplication } from "../SideBarData/VisaApplication";
import DraftPage from "../../pages/drafts/Draft";
import EditProfile from "../../pages/EditProfile";
import ChangePasswordPage from "../../pages/ChangePassword";
import DefultLayout from "../dashboardLaayout/DefultLayout";
import DefultLayout1 from "../dashboardLaayout/DefultLayout1";
import Maintenance from "../../pages/Maintenance";
import TermsUse from "../layouts/LoginLayout/TermsUse";
import PrivacyPolicy from "../layouts/LoginLayout/PrivacyPolicy";
import SupportPage from "../layouts/LoginLayout/SupportPage";
import Payments from "../../pages/Payments";
import PreviewAnswers from "../../pages/drafts/PreviewAnswers";
import LogoOnlyLayout from "../layouts/LoginLayout/LogoOnlyLayout";
import TravelDocument from "../../pages/TravelDocument";

const Authentication = () => {
  if (localStorage.getItem("code-verified")) {
    return <Navigate to="/dashboard"> </Navigate>;
  } else {
    return <Navigate to="/login"> </Navigate>;
  }
};

export default function ApRoutes() {
  return (
    <Routes>
      <Route path="/under-maintenance" element={<Maintenance />} />
      <Route element={<DefultLayout1 />}>
        <Route path="/termsofuse" element={<TermsUse />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/support" element={<SupportPage />} />
      </Route>

      <Route element={<DefultLayout />}>
        <Route path="/dashboard" element={<Dashboard />}></Route>
        <Route path="/payments" element={<Payments />}></Route>
        <Route path="/payments/:addon_id" element={<Payments />}></Route>
        <Route path="/application-detail" element={<PreviewAnswers />}></Route>
        <Route path="/FileFormOnline" element={<FileFormOnline />}></Route>
        <Route path="/draft-page" element={<DraftPage />}></Route>
        <Route path="/form-start" element={<FormStart />}></Route>
        <Route path="/edit-profile" element={<EditProfile />}></Route>
        <Route path="/change-password" element={<ChangePasswordPage />}></Route>
        <Route path="/travel-documents" element={<TravelDocument />}></Route>
        <Route path="*" element={<Dashboard />} />
      </Route>

      <Route element={<DashboardLayout />}>
        <Route path="/" element={<Authentication />} />
        <Route path="/programmes" element={<Dashboard />} />
        <Route path="/visa/:section" element={<VisaApplication />} />
        <Route path="/visa/:section/:sub_section" element={<VisaApplication />} />
        {/* Add-on Feature - Hidden */}
        {/* <Route path="/visa/addon/:addon_id/:section" element={<VisaApplication />} />
        <Route path="/visa/addon/:addon_id/:section/:sub_section" element={<VisaApplication />} /> */}
        {/* ================ */}
        <Route path="*" element={<Dashboard />} />
      </Route>

      <Route element={<LogoOnlyLayout />}>
        <Route path="/" element={<Authentication />} />
        <Route path="/login" element={<LoginForm />} />
        <Route path="/create-an-account" element={<CreateAccount />} />
        <Route
          path="/two-step-verification"
          element={<TwoStepWithCalidation />}
        />
        <Route path="/verification-otp/:type" element={<OTPVerification />} />

        <Route
          path="/two-step-verification-via-login"
          element={<TwoStepViaLogin />}
        />
        <Route
          path="/two-step-verification-via-forgot"
          element={<TwostepForgot />}
        />
        <Route path="/forgot-password" element={<ForGotPassword />} />
        <Route
          path="/verification-otp-login"
          element={<OrtpVerifyViaLogin />}
        />
        <Route path="*" element={<LoginForm />} />
      </Route>
    </Routes>
  );
}